import { Component } from '@angular/core';

/**
 * Header brand slot — renders the PROPERTY logo and nothing else.
 *
 * The property side is <app-logo-section>, untouched, so the whole
 * BrandingService logo pipeline (single/dual logos, logo_custom_url, iframe
 * behaviour) keeps working; slim sizing comes from a scoped context block in
 * assets/styles/components/header-logo/header-logo.scss.
 *
 * This component used to also render a hardcoded "getcovered" wordmark and a ×
 * separator (reskin unit D's co-brand lockup). That is gone: the header must
 * reflect only what the branding profile sends, never our own brand as a
 * default. A branding with no logo now shows an empty brand slot, which is the
 * intended behaviour, not a gap to fill.
 */
@Component({
    selector: 'app-cobrand-lockup',
    templateUrl: './cobrand-lockup.component.html',
    styleUrls: ['./cobrand-lockup.component.scss'],
    standalone: false
})
export class CobrandLockupComponent {}
